import { jsx } from 'react/jsx-runtime';
import { WoodyClient } from '@fabric/woody-client';
import { useContext, createContext, useState } from 'react';
import { getCompatEnv } from '@fabric-app/compat/capabilities/environment';
import { getCompatPlatform } from '@fabric-app/compat/capabilities/platform';
import { useClientLayoutEffect } from '@fabric-app/hooks/useClientLayoutEffect';

const WoodyContext = /* @__PURE__ */ createContext({});
class WoodyClientManager {
  constructor() {
    this.client = null;
    this.clientPromise = null;
    this.resolveClient = null;
    this.clientPromise = new Promise((resolve) => {
      this.resolveClient = resolve;
    });
  }
  /**
  * Returns the singleton instance of WoodyClientManager, creating it if it doesn't exist.
  */
  static getInstance() {
    if (!WoodyClientManager.instance) {
      WoodyClientManager.instance = new WoodyClientManager();
    }
    return WoodyClientManager.instance;
  }
  /**
  * Sets the WoodyClient instance and resolves the promise for any waiting consumers.
  */
  setClient(client) {
    this.client = client;
    if (this.resolveClient) {
      this.resolveClient(client);
    }
  }
  /**
  * Returns the WoodyClient instance. If the client is not yet available,
  * returns a promise that will resolve when the client is set.
  */
  async getClient() {
    if (this.client) {
      return this.client;
    }
    return this.clientPromise;
  }
}
const useWoody = () => useContext(WoodyContext);
const getWoodyClient = () => WoodyClientManager.getInstance().getClient();
const WoodyContextProvider = ({ logLevel, children }) => {
  const [client] = useState(() => {
    const newClient = new WoodyClient(getCompatEnv().WOODY_API_URL, void 0, logLevel, {
      device: getCompatPlatform().getPlatform(),
      webVersion: getCompatPlatform().getWebVersion()
    });
    WoodyClientManager.getInstance().setClient(newClient);
    return newClient;
  });
  useClientLayoutEffect(() => {
    if (!client) return;
    getCompatPlatform().getPlatformVersion().then((version) => {
      client.setAppVersion(version?.appVersion ?? "Unknown");
    });
  }, [
    client
  ]);
  return /* @__PURE__ */ jsx(WoodyContext.Provider, {
    value: {
      client,
      apiUrl: getCompatEnv().WOODY_API_URL
    },
    children
  });
};

export { WoodyContextProvider, getWoodyClient, useWoody };
//# sourceMappingURL=woody.js.map
